import BaseBlock from "@/ts/base/Components/Blocks/BaseBlock";

class Tabs extends BaseBlock {
	public sections!: NodeListOf<HTMLElement>;
	public nav!: HTMLUListElement;
	public init(): void {
		this.nav = this.block.querySelector(".section-content ul.nav") as HTMLUListElement;
		this.sections = this.block.querySelectorAll(".section-content .section");

		if (this.sections.length > 0) {
			this.createNavitation();

			this.nav.querySelectorAll(`button[data-bs-toggle="tab"]`)
				.forEach(btn => {
					btn.addEventListener("shown.bs.tab", this.onShown.bind(this));
				});
		}
	}

	protected createNavitation(): void {
		const tabContent: HTMLElement = document.createElement("div");
		tabContent.classList.add("tab-content");

		this.sections.forEach((section, index) => {
			const blockId = String(section.dataset.blockId);
			const tabPane = this.createTabPane(blockId, index);
			const btn = this.createTabButton(blockId, index);
			const li = this.createTabListItem();

			let name = this.getSectionName(section);
			if (name == "") {
				name = "Unknown";
			}

			btn.innerText = name;

			li.append(btn);
			this.nav.append(li);

			tabPane.append(section);
			tabContent.append(tabPane);
		});

		this.nav.after(tabContent);
	}

	protected createTabListItem(): HTMLLIElement {
		const el: HTMLLIElement = document.createElement("li");
		el.classList.add("nav-item");
		el.role = "presentation";

		return el;
	}

	protected createTabButton(blockId: string, index: number): HTMLButtonElement {
		const el: HTMLButtonElement = document.createElement("button");
		el.classList.add("nav-link");
		el.dataset.bsToggle = "tab";
		el.dataset.bsTarget = "#TabPane_" + blockId;
		el.type = "button";
		el.role = "tab";
		el.id = "Tab_" + blockId;
		el.setAttribute("aria-controls", blockId);

		if (index == 0) {
			el.classList.add("active");
			el.ariaSelected = "true";
		}
		else {
			el.ariaSelected = "false";
		}

		return el;
	}

	protected createTabPane(blockId: string, index: number): HTMLDivElement {
		const el = document.createElement("div");

		el.classList.add("tab-pane", "fade");
		el.role = "tabpanel";
		el.id = "TabPane_" + blockId;
		el.tabIndex = 0;
		el.setAttribute("aria-labelledby", "Tab_" + blockId);

		if (index == 0) {
			el.classList.add("show", "active");
		}

		return el;
	}

	protected getSectionName(section: HTMLElement): string {
		let name: string = String(section.dataset.name || "");

		if (name == "") {
			const heading = section.querySelector(".block-heading .heading") as HTMLElement;
			if (heading) {
				name = heading.innerText;
			}
		}

		return name;
	}

	protected onShown(e: Event): void {
		window.dispatchEvent(new Event("resize"));
	}
}

export default Tabs;
